/** Shared label style for small caps section headings */
export const sectionTitleClass =
  "text-xs font-semibold uppercase tracking-[0.16em] text-accent-muted";
